export default "./dist/stdassets/images/icons/back.png";